<template>
  <div>

    <div id="map-container" class="map-container"/>
    <!--    左侧栏搜索-->
    <div class="positionLeft">
      <div v-show="dkImg" class="dk" @click="controlBtn">
        <img src="../../static/imgages/sq.png" class="dkImg">
      </div>
      <div v-show="ifShowSearch" class="allInfoLeft">
        <!--        tzOption-->
        <!--        <div style="" class="se">-->
        <!--          <select class="selectOpt" @change="select1($event)">-->
        <!--            <option v-for="(item,index) in selectOption" :key="index" :label="item" :value="item"/>-->
        <!--          </select>-->
        <!--          <select class="selectOpt" @change="select2($event)">-->
        <!--            <option v-for="(item,index) in tzSelectOption" :key="index" :label="item" :value="item"/>-->
        <!--          </select>-->
        <!--        </div>-->

        <!--        <div class="itemChose">-->
        <!--          <div v-show="showRoad" class="roadChose" @click="road">路线</div>-->
        <!--          <div v-show="!showRoad" class="roadChose roadChoseTxt" @click="road">路线</div>-->
        <!--          <div v-show="showBridge" class="roadChose roadChoseBorder" @click="bridge">桥梁</div>-->
        <!--          <div v-show="!showBridge" class="roadChose roadChoseTxt" @click="road">桥梁</div>-->
        <!--          <div v-show="showSd" class="roadChose" @click="sd">隧道</div>-->
        <!--          <div v-show="!showSd" class="roadChose roadChoseTxt" @click="road">隧道</div>-->
        <!--        </div>-->
        <div class="selectLast" style=" ">
          <div class="eachSelect">
            <select class="eachSelectFor" @change="changeSelect0">
              <option v-for="item in options0" :label="item.label" :value="item.value" style="font-size: 16px;"/>
            </select>
          </div>
          <div class="eachSelect">
            <select class="eachSelectFor" @change="changeSelect1" >
              <option v-for="item in options1" :label="item.label" :value="item.value" style="font-size: 16px;"/>
            </select>
          </div>

          <div class="eachSelect">
            <select class="eachSelectFor" @change="changeSelect2">
              <option v-for="item in options2" :label="item.label" :value="item.value" style="font-size: 16px;"/>
            </select>
          </div>
        </div>
        <div v-show="!showSearch" class="cql2" style="margin-bottom: 8px">
          <div
            style="background: #ffffff;border-radius: 8px;
  width: 418px;height: 42px;display: flex;flex-wrap: wrap;align-items: center;">
            <img
              src="../../static/imgages/searc.png"
              style="width: 14px;height: 14px;margin-right: 8px;margin-left: 16px">
            <input
              v-model="roadbh"
              type="text"
              placeholder="可输入路线编号进行查询"
              style="background-color: #FFFFFF;height: 42px;width: 85%;border: none"
              @click="allowWatch"
            >
            <img v-show="roadbh" src="../../static/imgages/cha.png" style="width: 10px;height: 10px;cursor: pointer;" @click="cha">

          </div>
        </div>
        <div v-show="!showSearch" style="display: flex">
          <div class="txtK" >
            <div
              class="titstyle"
              style="font-size: 14px;">K:
            </div>
            <input v-model="roadK" type="text" placeholder="桩号" style="width: 100%;border: none">
          </div>
          <div
            v-show="!showSearch"
            style=""
            class="styImg"
          >
            <img src="../../static/imgages/jia.png" style="width: 18px;height: 18px;">

          </div>

          <input
            v-show="!showSearch"
            v-model="roadAdd"
            type="text"
            placeholder="米数"
            class="inp"
            style="">
          <div
            class="sousuo"
            @click="cql0">搜索
          </div>
        </div>

        <div v-show="showSearchBridge" style="margin-bottom: 8px;display: flex;height: 42px">
          <input
            v-model="bridgeName"
            type="text"
            placeholder="请输入桥梁名称"
            class="searchName"
            @click="allowWatch"
          >
          <img
            v-show="bridgeName"
            src="../../static/imgages/cha.png"
            style="width: 10px;height: 10px;cursor: pointer;position: absolute;margin-left:290px;margin-top: 16px"
            @click="chaBridge">

          <div
            class="sousuo"
            @click="cql">搜索
          </div>
        </div>
        <div v-show="showSearchSd" style="margin-bottom: 8px;display: flex;height: 42px">
          <input
            id="abc"
            v-model="sdName"
            type="text"
            placeholder="请输入隧道名称"
            class="searchName"
            @click="allowWatch"
          >
          <img
            v-show="sdName"
            src="../../static/imgages/cha.png"
            style="width: 10px;height: 10px;cursor: pointer;position: absolute;margin-left:290px;margin-top: 16px"
            @click="chaSd">
          <div
            class="sousuo"
            @click="cql">搜索
          </div>
        </div>
        <!--        v-show="!showRoad"-->

        <div class="treeStyle">
          <div v-show="current==0" class="infoList">
            <div
              v-for="(item,i) in lxlist"
              :key="i"
              :class="isactive == i ? 'addclass' : 'choseInfo' "
              tabindex="0"
              style="display: flex;align-items: center"
              @click="chickItem(0,item,i)"
            >
              <div>
                <!--                <img src="../../static/imgages/road.png" class="roadImg">-->
                <img src="../../static/imgages/searc.png" style="width: 14px;height: 14px;margin-left: 20px">
              </div>
              <div class="choseInfoTit" style="display:flex;align-items: center;">
                {{ item.properties.lxbm }} {{ item.properties.lxjc }}
                ({{ item.properties.qdzh }}-{{ item.properties.zdzh }})
              </div>
              <div>
                <img src="../../static/imgages/you.png" style="width: 8px;height: 14px;margin-left: 20px">
              </div>
            </div>

          </div>

          <div v-show="current==1" class="infoList" style="height: 588px">
            <div
              v-for="(item,i) in qllist"
              :key="i"
              :class="isactive == i ? 'addclass' : 'choseInfo' "
              tabindex="1"
              style="display: flex;align-items: center"
              @click="chickItem(1,item,i)">
              <div>
                <!--                <img src="../../static/imgages/road.png" class="roadImg">-->
                <img src="../../static/imgages/searc.png" style="width: 14px;height: 14px;margin-left: 20px">
              </div>
              <div class="choseInfoTit">
                {{ item.properties.benm }}
              </div>
              <div>
                <img src="../../static/imgages/you.png" style="width: 8px;height: 14px;margin-left: 20px">
              </div>
            </div>
          </div>

          <div v-show="current==2" class="infoList" style="height: 588px">
            <div
              v-for="(item,i) in sdlist"
              :key="i"
              :class="isactive == i ? 'addclass' : 'choseInfo' "
              tabindex="2"
              style="display: flex;align-items: center"
              @click="chickItem(2,item,i)">
              <div>
                <!--                <img src="../../static/imgages/road.png" class="roadImg">-->
                <img src="../../static/imgages/searc.png" style="width: 14px;height: 14px;margin-left: 20px">
              </div>
              <div class="choseInfoTit">
                {{ item.properties.benm }}
              </div>
              <div>
                <img src="../../static/imgages/you.png" style="width: 8px;height: 14px;margin-left: 20px">
              </div>
            </div>
          </div>

        </div>
      </div>
      <div v-show="sqImg" class="sq" @click="controlBtn">
        <img src="../../static/imgages/dk.png" class="dkImg">
      </div>
    </div>

  </div>

</template>
<script>
// 引入leaflet模块
import 'leaflet/dist/leaflet.css'
import 'leaflet/dist/leaflet.css'
import redMarker from '../assets/t.png'
import bMarker from '../assets/b.png'
import sMaker from '../assets/yuan.png'
import L from 'leaflet'
import 'leaflet.chinatmsproviders'
import axios from 'axios'
import 'leaflet-wfst'
import { getsdViewAPI, getqlViewAPI, gettdgeocodeAPI, getpViewAPI, getradiusAPI } from '@/api/api'
import { getRoadTypeAndSon } from '../api/api'

export default {

  name: 'MapView',
  components: {},

  data() {
    return {
      preventWatch: true, // 阻止监听
      change: true,
      chosed0: 0,
      chosed1: '',
      chosed2: 0,
      options0: [{
        value: '0',
        label: '路线'
      }, {
        value: '1',
        label: '桥梁'
      }, {
        value: '2',
        label: '隧道'
      }],
      options1: [{
        value: '0',
        label: '全部'
      }, {
        value: '1',
        label: '高速公路'
      }, {
        value: '2',
        label: '普通国道'
      }, {
        value: '3',
        label: '普通省道'
      }],
      options2: [{
        value: '331000',
        label: '台州'
      }, {
        value: '331002',
        label: '椒江区'
      }, {
        value: '331003',
        label: '黄岩区'
      }, {
        value: '331004',
        label: '路桥区'
      }, {
        value: '331023',
        label: '天台县'
      }, {
        value: '331024',
        label: '仙居县'
      }, {
        value: '331022',
        label: '三门县'
      }, {
        value: '331082',
        label: '临海市'
      }, {
        value: '331081',
        label: '温岭市'
      }, {
        value: '331083',
        label: '玉环市'
      }],
      roadType: '',
      tzSon: '',
      ifCancel: false,
      ifCancelTimes: 1,
      isactive: -1,
      bridgeName: '',
      sdName: '',
      showSearch: false,
      showSearchBridge: false,
      showSearchSd: false,
      showRoad: false,
      showBridge: true,
      showSd: true,
      dkImg: true,
      sqImg: false,
      ifShowSearch: false,
      current: 0,
      showIndex: 0,
      ztreeObj: null,
      ifshow: false,
      map: null,
      GaodeUrl: 'http://webrd01.is.autonavi.com/appmaptile?x={x}&y={y}&z={z}&lang=zh_cn&size=1&scale=1&style=8',
      WMTSUrl: 'https://tzmap.tzyuansheng.com/geoserver/fangjia/wms?',
      WFSUrl: 'https://tzmap.tzyuansheng.com/geoserver/wfs?',
      WMSOption: {
        layers: 'tzgs-lx1',
        format: 'image/png',
        transparent: true
        // 查询函数
        // CQL_FILTER : "name='太阳宫'"
      },
      wsmsdoption: {
        layers: 'sdview',
        format: 'image/png',
        transparent: true
        // 查询函数
        // CQL_FILTER : "name='太阳宫'"
      },
      wsmqloption: {
        layers: 'qlview',
        format: 'image/png',
        transparent: true
        // 查询函数
        // CQL_FILTER : "name='太阳宫'"
      },

      wsmoptionoption: {
        layers: 'pview',
        format: 'image/png',
        transparent: true
        // 查询函数
        // CQL_FILTER : "name='太阳宫'"
      },

      wsmxianption: {
        layers: 'xian',
        format: 'image/png',
        transparent: true
        // 查询函数
        // CQL_FILTER : "name='太阳宫'"
      },

      wsmshiption: {
        layers: 'shi',
        format: 'image/png',
        transparent: true
        // 查询函数
        // CQL_FILTER : "name='太阳宫'"
      },

      sdlist: [], // 隧道列表
      sdGroup: L.featureGroup(),
      sdfeature: {}, // 隧道数据
      // sdfeatureGroup : L.featureGroup(),

      qllist: [], // 桥梁列表
      qlGroup: L.featureGroup(),

      lxlist: [], // 桥梁列表
      lxGroup: L.featureGroup(),
      lxselect: L.featureGroup(),

      selectlx: '',
      selectGroup: L.featureGroup(),
      selectitem: '', // 选择的桥梁或者隧道的

      cqldata: '',
      roadbh: '', // 道路编号
      roadK: '', // 道路k值
      roadAdd: '', // k值后的+号
      blueIcon: L.icon({
        iconUrl: redMarker,
        iconSize: [24, 24],
        iconAnchor: [12, 12]
      }),
      bIcon: L.icon({
        iconUrl: bMarker,
        iconSize: [24, 24],
        iconAnchor: [12, 12]
      }),
      sIcon: L.icon({
        iconUrl: sMaker,
        iconSize: [18, 18],
        iconAnchor: [9, 9]
      }),
      zoom: 9,
      info: L.control(),
      type: ''

    }
  },
  computed: {},
  watch: { // 监听是否选择下拉
    roadType(newName, oldName) {
      this.querylxwfs(this.roadbh, newName)
    },
    // 阻止监听事件发生
    preventWatch(newV, oldV) {
      if (newV != oldV) {
        this.change = false
        return
      }
    },
    // 路线编号搜索框内容监听
    roadbh(newValue, oldValue) {
      if (this.change == true) {
        this.watchUseCql()
      }
    },
    // 桥梁搜索框内容监听
    bridgeName(newValue, oldValue) {
      if (this.change == true) {
        this.cql()
      }
    },
    // 隧道搜索框内容监听
    sdName(newValue, oldValue) {
      if (this.change == true) {
        this.cql()
      }
    }
    // chosed1(newName, oldName) {
    //   this.querylxwfs(this.roadbh, newName)
    // },
    // chosed2(newName, oldName) {
    //   this.querylxwfs(this.roadbh, newName)
    // }
  },

  mounted() {
    this.initDate()
    this.initsdwfs()
    this.initqlwfs()
    // this.initlxwfs()
    this.initTz()
    // this.querylxwfs()
    //   this.initpointwfs();
    // this.getwfs()
  },

  methods: {
    // 初始触发
    initTz() {
      const params = {}
      params.org = this.options2[this.chosed2].value
      this.chosed2 = this.options2[this.chosed2].value
      params.pageSize = '30'
      params.lxbm2 = this.roadbh
      console.log('初始查询', params)
      getRoadTypeAndSon(params).then(res => {
        res.data.data.list.map(rr => {
          rr.properties = {}
          rr.properties.lxbm = rr.lxbm2
          rr.properties.lxjc = rr.lxjc
          rr.properties.qdzh = rr.qdzh
          rr.properties.zdzh = rr.zdzh
        })
        this.lxlist = res.data.data.list
        console.log('初始区域查询结果', res)
      })
    },
    // 监听调用
    watchUseCql() {
      const params = {}
      params.org = this.chosed2
      if (this.chosed1 != 0) {
        params.type = this.chosed1
      }
      params.pageSize = '30'
      params.lxbm2 = this.roadbh
      console.log('监听查询', params)
      getRoadTypeAndSon(params).then(res => {
        res.data.data.list.map(rr => {
          rr.properties = {}
          rr.properties.lxbm = rr.lxbm2
          rr.properties.lxjc = rr.lxjc
          rr.properties.qdzh = rr.qdzh
          rr.properties.zdzh = rr.zdzh
        })
        this.lxlist = res.data.data.list
        console.log('监听查询结果', res)
      })
    },
    // 路线、桥梁、隧道
    changeSelect0(e) {
      this.chosed0 = e.target.value
      if (this.chosed0 == '0') {
        this.road()
      } else if (this.chosed0 == '1') {
        this.bridge()
      } else if (this.chosed0 == '2') {
        this.sd()
      }

      // if(this.)
    },
    // 修改路线类型下拉触发
    changeSelect1(e) {
      this.chosed1 = e.target.value
      const params = {}
      if (this.chosed1 != 0) {
        params.type = this.chosed1
      }
      params.lxbm2 = this.roadbh
      params.org = this.chosed2
      // axios.get('http://192.168.16.111:8080/api/example/Lx/infoList', params).then(res => {
      //   console.log('下拉选择路段类别查询结果', res)
      // })
      params.pageSize = '30'
      console.log('下拉选择路段类别查询：', params)
      getRoadTypeAndSon(params).then(res => {
        res.data.data.list.map(rr => {
          rr.properties = {}
          rr.properties.lxbm = rr.lxbm2
          rr.properties.lxjc = rr.lxjc
          rr.properties.qdzh = rr.qdzh
          rr.properties.zdzh = rr.zdzh
        })
        this.lxlist = res.data.data.list
        console.log('下拉选择路段类别查询结果', res)
      })
    },
    // 修改台州区域下拉触发
    changeSelect2(e) {
      this.chosed2 = e.target.value
      const params = {}
      params.org = this.chosed2
      if (this.chosed1 != 0) {
        params.type = this.chosed1
      }
      params.lxbm2 = this.roadbh
      params.pageSize = '30'
      console.log('下拉选择区域查询：', params)
      getRoadTypeAndSon(params).then(res => {
        res.data.data.list.map(rr => {
          rr.properties = {}
          rr.properties.lxbm = rr.lxbm2
          rr.properties.lxjc = rr.lxjc
          rr.properties.qdzh = rr.qdzh
          rr.properties.zdzh = rr.zdzh
        })
        this.lxlist = res.data.data.list
        console.log('下拉选择路段类别查询结果', res)
      })
    },
    // 路线编号框中的清除按钮，清除道路编号
    cha() {
      this.roadbh = ''
      this.lxGroup.clearLayers()
      this.change = true// 重置监听开关，打开监听
    },
    // 桥梁搜索框中的清除按钮，清除道路编号
    chaBridge() {
      this.bridgeName = ''
      this.change = true
    },
    // 隧道搜索框中的清除按钮，清除道路编号
    chaSd() {
      this.sdName = ''
      this.change = true
    },
    rp(data) { // 替换符合
      return String(data).replace('.', '+')
    },
    // 点击是否显示右侧栏信息
    ifShow() {
      this.ifshow = true
    },
    // 点击右侧关闭按钮，关闭右侧栏
    closeShow() {
      this.ifshow = false
    },

    hello(e) {
      e.layer.feature.properties
      console.log('hello' + e)
    },

    addItems(features, icon, type) { // 添加点数据
      var that = this
      // console.log('addItems:features' + features)
      const markerArr = []// marker数组

      features.map(item => {
        // console.log("aaaaaaaaa",item.properties);

        const maker = L.marker([item.properties.y, item.properties.x], { icon: icon })
          .bindPopup(`<b>名称:</b>${item.properties.benm}<br>
					  <b>线路:</b>${item.properties.rdcd}${item.properties.rdnm}<br>
            <b>区域:</b>${item.properties.orgid}<br>
					  <b>中心桩号:</b>K${item.properties.cemark.replace('.', '+')}<br>
					  <b>经纬度:</b>${item.properties.x},${item.properties.y}`)
        // .openPopup()
        Object.defineProperties(maker, {
          id: {
            // 表格的id
            value: item.properties.y + ',' + item.properties.x
          }
        })

        maker.on('mouseover', function(event) {
          maker.openPopup()
        })

        maker.on('mouseout', function(event) {
          maker.closePopup()
        })

        maker.on('click', function(event) {
          console.log(that.info)
          console.log(type)
          that.type = type
          that.sdfeature = item.properties

          console.log(that.sdfeature)
          // 控制右侧栏
          that.ifshow = true
        })

        markerArr.push(maker)
      })
      //  group = L.layerGroup(markerArr);
      //  group.addTo(this.map);
      return markerArr
    },

    filterSdData(features) { // 过滤数据隧道根据级别显示
      let data = features

      var that = this

      data = features.filter(function(x) {
        // console.log(x);
        return that.map.getBounds().contains(L.latLng([x.properties.y, x.properties.x]))
      })
      // console.log('data' + data)

      return data
    },

    initDate() {
      // 天地图参数
      const tileOptions = {
        minZoom: 0,
        maxZoom: 17, // 天地图经纬度投影的最大缩放级别为17,继续放大则没有瓦片可以拉取
        unlimited: true, // 不限制缩放,重写GridLayer的_removeAllTiles方法,实现在最大缩放级别下,能够继续放大图片
        tileSize: 256, // 使用L.CRS.EPSG4326时需要放开这两个参数
        zoomOffset: 1 // 使用L.CRS.EPSG4326时需要放开这两个参数
      }

      // const a =  L.tileLayer.wms(this.WMTSUrl, this.wsmxianption);//.addTo(this.map)
      const b = L.tileLayer.wms(this.WMTSUrl, this.WMSOption)// .addTo(this.map)
      const c = L.tileLayer.wms(this.WMTSUrl, this.WMSOption)// .addTo(this.map)
      // const d = L.tileLayer.wms(this.WMTSUrl, this.wsmoptionoption)// .addTo(this.map) 原注销，因核对数据打开
      // const e = L.tileLayer.wms(this.WMTSUrl, this.wsmoptionoption)// .addTo(this.map)原注销，因核对数据打开

      // 定义天地图影像地图,c是经纬度，w是墨卡托
      var normalm = L.tileLayer.chinaProvider('TianDiTu_c.Normal.Map', tileOptions)
      // 定义天地图影像注记
      var normala = L.tileLayer.chinaProvider('TianDiTu_c.Normal.Annotion', tileOptions)
      // 定义天地图全球境界
      // var normala = L.tileLayer.chinaProvider('TianDiTu_c.Satellite.Realm', tileOptions)
      // 组合地图和注记
      // var normal = L.layerGroup([normalm, normala, normalr])
      var normal = L.layerGroup([normalm, normala])// 因核对数据，加上, c, d

      // 矢量地图
      const vectorMap = L.tileLayer.chinaProvider('TianDiTu_c.Satellite.Map', tileOptions)
      const vectorAnn = L.tileLayer.chinaProvider('TianDiTu_c.Satellite.Annotion', tileOptions)
      var vecGroup = L.layerGroup([vectorMap, vectorAnn])// 因核对数据，加上, b, e

      // 初始化地图
      this.map = L.map('map-container', {
        // crs: L.CRS.EPSG3857,//默认,天地图web墨卡托投影使用(此时天地图最大缩放级别为18)
        crs: L.CRS.EPSG4326, // 天地图经纬度投影使用(此时天地图最大缩放级别为17,但此时的17级与3857和4490的18级一样)
        // crs: CRS_4490,//天地图经纬度投影使用(此时天地图最大缩放级别为18)
        center: [28.37176, 121.38595],
        maxZoom: 20, // 设置unlimited后，天地图可以实现缩放到20也有地图
        // maxZoom: 17,
        minZoom: 9,
        zoom: 10,
        layers: [normal], // 加载天地图经纬度投影作为底图
        zoomControl: false,
        attributionControl: false
      })

      const layers = {
        baseLayers: {
          矢量地图: normal,
          影像地图: vecGroup
        },
        overlays: {
          桥梁: this.qlGroup,
          隧道: this.sdGroup
        }
      }

      var _layerControl = L.control
        .layers(layers.baseLayers, layers.overlays, { collapsed: true })
        .addTo(this.map)

      this.map.on('dblclick', (e) => {
        console.log(e.latlng)
        const lng = e.latlng.lng
        const lat = e.latlng.lat

        getradiusAPI(lng, lat).then(response => {
          console.log('getpViewAPI:' + response.data.data[0])

          const data = response.data.data[0]
          //  let item  = data
          // let x = item.properties.x;
          // let y=  item.properties.y;

          //     console.log( "data.type" , data.type);
          // this.map.setZoom(14);
          // this.map.panTo([y,x]);

          gettdgeocodeAPI(lng, lat).then(response => {
            console.log('gettdgeocodeAPI' + response.data.result.addressComponent.county)
            const selectp = {
              'x': data.x,
              'y': data.y,
              'data': { 'lxjc': data.rdname, 'lxbm': data.rdcd, 'type': data.type },
              'query': 'K' + data.k,
              'county': response.data.result.addressComponent.county
            }
            this.addSelectItem(selectp, this.sIcon)
          })
            .catch(function(error) {
              console.log(error)
            })
        })
      })
      this.map.on('zoomend', (e) => { // 地图zomme
        // 获取当前放大或者缩小的等级
        const scale = e.target.getZoom()
        console.log('************', scale)
        const putGroup = this.lxGroup
        if (scale >= 17) { // 暂时注销放大高亮，用于核对上下行数据
          this.lxGroup.clearLayers()
        } else {
          console.log('放大，', this.lxselect)
          this.lxGroup = this.lxselect
          this.lxGroup.addTo(this.map)
        }

        // //  console.log("getZoom" + scale);
        // // this.hello(scale);
        // this.zoom = scale
        // // this.initsdwfs();

        // console.log('this.sdGroup' + this.sdGroup)

        // // 处理桥梁数据
        // this.sdGroup.clearLayers()
        // let sddata = this.filterSdData(this.sdlist)
        // let sdmarkers = this.addItems(sddata, this.blueIcon, 'sd')
        // this.sdGroup = L.layerGroup(sdmarkers)
        // this.sdGroup.addTo(this.map)

        // // 处理桥梁数据
        // this.qlGroup.clearLayers()
        // let qldata = this.filterQlData(this.qllist)
        // let qlmarkers = this.addItems(qldata, this.bIcon, 'ql')

        // this.qlGroup = L.layerGroup(qlmarkers)
        // this.qlGroup.addTo(this.map)
      })

      // this.info = L.control();

      // this.info.onAdd = function (map) {
      //   this._div = L.DomUtil.create('div', 'info') // create a div with a class "info"
      //   //  this.update();
      //   return this._div
      // }

      // // method that we will use to update the control based on feature properties passed
      // // info.update = function (props) {
      // //     this._div.innerHTML = '<h4>US Population Density</h4>' +  (props ?
      // //         '<b>' + props.name + '</b><br />' + props.density + ' people / mi<sup>2</sup>'
      // //         : 'Hover over a state');
      // // };

      // this.info.addTo(this.map)

      //     this.map = L.map('map-container', {
      //       center: [28.83, 121.10],
      //       zoom: 12
      //   });

      // //   this.map.removeLayer(name)  // 移除图层

      //   L.tileLayer.chinaProvider(  //天地图的底图
      //   'TianDiTu.Satellite.Map',
      //   {
      //       key: '058990140981d02ee9e3679fb6416cab',
      //       maxZoom:18,
      //       minZoom:1,
      //   }).addTo(this.map);

      //  L.tileLayer.chinaProvider(  //天地图的注解
      //   'TianDiTu.Normal.Annotion',
      //   {
      //       key: '058990140981d02ee9e3679fb6416cab',
      //       maxZoom:18,
      //       minZoom:1,
      //   }).addTo(this.map);

      //  // 加载geoserver发布的wmts服务
      // L.tileLayer.wms(this.WMTSUrl, this.wsmshiption).addTo(this.map)

      this.map.doubleClickZoom.disable()
      // L.tileLayer.wms(this.WMTSUrl, this.wsmsdoption).addTo(this.map);
    },

    // 加载隧道数据
    initsdwfs(cql) {
      // 单击地图，获取geojson，渲染要素
      getsdViewAPI(cql)
        .then(response => {
          console.log(response.data.features)
          this.sdlist = response.data.features

          // let sddata = this.filterSdData(this.sdlist)
          const markers = this.addItems(this.sdlist, this.blueIcon, 'sd')

          markers.map(item => {
            this.sdGroup.addLayer(item)
          })

          //  this.sdGroup.addTo(this.map);

          // this.sdGroup = L.layerGroup(markers)
          // this.sdGroup.addTo(this.map)

          console.log('this.sdlist' + this.sdlist)
        })
        .catch(function(error) {
          console.log(error)
        })
    },

    // 加载桥梁数据
    initqlwfs(cql) {
      // 单击地图，获取geojson，渲染要素
      getqlViewAPI(cql)
        .then((response) => {
          console.log('---------', response)
          //   console.log(response.data.features);
          // this.addItems(response.data.features,this.bIcon);
          this.qllist = response.data.features // 保存全部桥梁数

          // let qldata = this.filterQlData(this.qllist)
          const markers = this.addItems(this.qllist, this.bIcon, 'ql')
          this.qlGroup.clearLayers() // 清除

          markers.map(item => {
            this.qlGroup.addLayer(item)
          })
          // this.qlGroup.clearLayers();
          //   this.qlGroup.addTo(this.map)
        })
        .catch(function(error) {
          console.log(error)
        })
    },
    // 加载线路数据
    initlxwfs(cql) {
      let feature_url = this.WFSUrl + 'request=GetFeature&version=1.1.0&typeName=fangjia:tzgs-lx1&outputFormat=application/json'

      if (cql) {
        feature_url = feature_url + '&CQL_FILTER=' + cql
      }

      // 单击地图，获取geojson，渲染要素
      console.log(feature_url)
      axios.get(feature_url)
        .then((response) => {
          //   console.log(response.data.features);
          // this.addItems(response.data.features,this.bIcon);
          const m = new Map()

          response.data.features.map(item => {
            //   console.log(item.properties);
            m.set(item.properties.lxbm, item)
          })
          this.lxlist = []
          m.forEach((k, v) => {
            this.lxlist.push(k)
          })
          // this.lxlist = [];
          // for(var key in m){
          //     this.lxlist.push(m[key]);
          // }
          // console.log("lxlist:" + this.lxlist);

          //  this.lxlist = response.data.features // 保存全部桥梁数
          // let qldata = this.filterQlData(this.qllist)
          // let markers = this.addItems(qldata, this.bIcon, 'ql')

          // this.qlGroup = L.layerGroup(markers)
          // this.qlGroup.addTo(this.map)
        })
        .catch(function(error) {
          console.log(error)
        })
    },

    // 加载线路数据
    querylxwfs(cql, newName) {
      console.log('加载线路数据传值：', cql, this.chosed2)
      const query = `lxbm = '${cql}' and org='${this.chosed2}'`
      const queryencodeURI = encodeURIComponent(query)
      let feature_url = this.WFSUrl + 'request=GetFeature&version=1.1.0&typeName=fangjia:tzgs-lx1&outputFormat=application/json'

      if (cql) {
        feature_url = feature_url + '&CQL_FILTER=' + queryencodeURI
      }

      // 单击地图，获取geojson，渲染要素
      const params = {}
      if (newName && newName != '0') {
        params.type = newName
      } // 判断有无选择下拉
      console.log('参数', params)
      axios.get(feature_url, params)
        .then((response) => {
          const data = response.data
          console.log(data.features[0].geometry.coordinates[0][0])

          const xy = data.features[0].geometry.coordinates[0][0]

          this.map.panTo([xy[1], xy[0]])

          this.lxselect = L.geoJSON(data, {
            style: {
              'color': '#546CEA',
              'fillColor': '#546CEA',
              'opacity': 0.7,
              'weight': 5
            }
          })
          this.lxGroup.clearLayers()
          this.lxGroup = this.lxselect
          // 再次点击取消高亮
          this.lxGroup.addTo(this.map)

          if (this.ifCancel == false) {
            this.lxGroup.addTo(this.map)
          } else if (this.ifCancel == true) {
            // this.lxGroup.clear(this.map)
            this.lxGroup.clearLayers(this.map)
          }

          //   console.log(response.data.features);
          // this.addItems(response.data.features,this.bIcon);
          //   let m = new Map();

          //   response.data.features.map(item=>{
          //    //   console.log(item.properties);
          //       m.set(item.properties.lxbm,item );
          //   })
          //  this.lxlist = [];
          //  m.forEach((k,v)=>{
          //     this.lxlist.push(k);
          //  })

          // this.lxlist = [];
          // for(var key in m){
          //     this.lxlist.push(m[key]);
          // }
          // console.log("lxlist:" + this.lxlist);

          //  this.lxlist = response.data.features // 保存全部桥梁数
          // let qldata = this.filterQlData(this.qllist)
          // let markers = this.addItems(qldata, this.bIcon, 'ql')

          // this.qlGroup = L.layerGroup(markers)
          // this.qlGroup.addTo(this.map)
        })
        .catch(function(error) {
          console.log(error)
        })
    },

    // 加载点数据
    querypwfs(data, k1, k2, querydata) {
      // that = this;
      // 单击地图，获取geojson，渲染要素
      getpViewAPI(data.lxbm, k1, k2).then(response => {
        console.log('getpViewAPI:' + response)
        //  //   let  data  = response.data;
        const item = response.data.features[0]
        const x = item.properties.x
        const y = item.properties.y

        console.log(item + ',x' + x + ',y' + y)

        this.map.setZoom(14)
        setTimeout(() => {
          this.map.panTo([y, x])
          data.type = '0'
          gettdgeocodeAPI(x, y).then(response => {
            console.log('gettdgeocodeAPI' + response.data.result.addressComponent.county)
            const selectp = {
              'x': x,
              'y': y,
              'data': data,
              'query': querydata,
              'county': response.data.result.addressComponent.county
            }
            this.addSelectItem(selectp, this.sIcon)
          })
            .catch(function(error) {
              console.log(error)
            })
        }, 500)
      })

      //  //   let  data  = response.data;
      //    console.log(response);
      //      let item  = response.data.features[0] ;
      //      let x = item.properties.x;
      //      let y=  item.properties.y;

      //      console.log( item + ",x" + x + ",y" + y);
      //     this.map.setZoom(14);
      //     this.map.panTo([y,x]);

      //     let selectp = {"x":x, "y":y};

      //     this.addSelectItem(selectp, this.bIcon);

      // gettdgeocodeAPI(x,y).then(response => {
      //         console.log("gettdgeocodeAPI"  + response);
      //     })
      //     .catch(function (error) {
      //       console.log(error)
      //     })

      // })
    },

    addSelectItem(item, icon) { // 添加单点的提示
      console.log('itemitemitemitemitemitemitemitemitemitemitemitemitemitemitem' + item.data.type)

      let type = ''
      if (item.data.type != '0') {
        type = `(${item.data.type === '1' ? '上行' : '下行'})`
      }
      const maker = L.marker([item.y, item.x], { icon: icon })
        .bindPopup(`区县:${item.county}
       <br>线路:${item.data.lxbm}${item.data.lxjc}
       <br>桩号:${item.query.replace('.', '+')}${type}
       <br>经纬度:${item.y},${item.x}`
        )

      //  .addTo(this.map);

      // Object.defineProperties(maker, {
      //         id: {
      //           //表格的id
      //           value:item.properties.y +","+item.properties.x
      //         },
      //       });

      maker.on('mouseover', function(event) {
        maker.openPopup()
      })

      maker.on('mouseout', function(event) {
        maker.closePopup()
      })

      maker.on('click', function(event) {
        maker.openPopup()
        // console.log(that.info)
        // console.log(type)
        // that.type = type
        // that.sdfeature = item.properties

        // console.log(that.sdfeature)
        // // 控制右侧栏
        // that.ifshow = true
      })
      this.selectGroup.clearLayers()
      this.selectGroup.addLayer(maker)
      //  this.qlGroup = L.layerGroup(markers)
      this.selectGroup.addTo(this.map)
      maker.openPopup()
    },
    cql0() {
      if (!this.roadAdd) { // 如果没有输入米数，即不是查询具体点位
        const params = {}
        params.lxbm2 = this.roadbh
        params.org = this.chosed2
        params.pageSize = '30'
        console.log('路线编号查询：', params)
        getRoadTypeAndSon(params).then(res => {
          res.data.data.list.map(rr => {
            rr.properties = {}
            rr.properties.lxbm = rr.lxbm2
            rr.properties.lxjc = rr.lxjc
            rr.properties.qdzh = rr.qdzh
            rr.properties.zdzh = rr.zdzh
          })
          this.lxlist = res.data.data.list
          console.log('编号查询结果：', this.lxlist)
        })
      } else {
        this.lxlist.map((item, index) => {
          if (item.lxbm2 == this.roadbh) {
            this.isactive = index
          }
        })
        if (this.lxlist[this.isactive]) {
          console.log('查点：', parseInt(this.roadK) < parseInt(this.lxlist[this.isactive].qdzh.split('+')[0].slice(1)))
          if (parseInt(this.roadK) < parseInt(this.lxlist[this.isactive].qdzh.split('+')[0].slice(1))) {
            alert('请输道路范围内的桩号111！')
            return
          } else {
            if (parseInt(this.roadK) == parseInt(this.lxlist[this.isactive].qdzh.split('+')[0].slice(1)) && parseInt(this.roadAdd) < parseInt(this.lxlist[this.isactive].qdzh.split('+')[1])) {
              alert('请输道路范围内的米数！')
              return
            } else {
              this.cql()
            }
          }
          console.log('查点：', parseInt(this.lxlist[this.isactive].qdzh.split('+')[0].slice(1)))
        } else {
          alert('请输入正确的道路编号与桩号！')
          return
        }
      }
    },

    cql() {
      if (!this.roadAdd) {
        this.roadAdd = '0'
      }
      this.cqldata = 'K' + this.roadK + '+' + this.roadAdd
      // console.log('查询条件', this.cqldata)
      // console.log('选择的路线', this.selectlx)
      if (this.showRoad == false) {
        this.selectlx = this.lxlist[this.isactive].properties
        if (this.selectlx === '') {
          alert('请选择道路')
          return
        }

        console.log(this.cqldata.indexOf('k'))
        //  console.log(this.cqldata.indexOf("K")  );
        if (!this.roadType) {

        }
        if ((this.cqldata.indexOf('k') != -1 || this.cqldata.indexOf('K') != -1) && this.cqldata.indexOf('+') != -1) {
        } else {
          alert('请输入正确的内容,例如K9+123')
          return
        }

        const p = this.cqldata.split('+')
        const k1 = parseInt(p[0].replace('K', '').replace('k', ''))
        const k2 = parseInt(p[1])
        if (!this.myIsNaN(k1) || !this.myIsNaN(k2)) {
          alert('请输入正确的数字,例如K9+123')
          return
        }

        const k3 = k1 + k2 / 1000
        const k4 = k1 + (k2 + 5) / 1000

        // console.log('1111111111111111:' + k3 + ',' + k4)
        this.querypwfs(this.selectlx, k3, k4, this.cqldata)
        console.log('定位', this.selectlx)

        this.selectlx = ''
        return

        // console.log(p[0].p[1] );

        // 查找点信息
      } else if (this.showBridge == false) { // 桥梁
        this.initqlwfs(this.bridgeName)
      } else if (this.showSd == false) { // 隧道
        this.initsdwfs(this.sdName)
      }
    },

    querynear(x, y) { // 搜索附近的点
      let feature_url = this.WFSUrl + 'request=GetFeature&version=1.1.0&typeName=fangjia:tzgs-lx1&outputFormat=application/json'

      if (cql) {
        feature_url = feature_url + '&CQL_FILTER=' + queryencodeURI
      }
    },

    myIsNaN(value) {
      return typeof value === 'number' && !isNaN(value)
    },

    // 打开、收起
    controlBtn() {
      this.dkImg = !this.dkImg
      this.ifShowSearch = !this.ifShowSearch
      this.sqImg = !this.sqImg
    },

    // 搜索栏点击转换
    road() {
      this.current = 0
      this.showRoad = false
      this.showBridge = true
      this.showSd = true
      this.showSearchBridge = false
      this.showSearchSd = false
      this.showSearch = false
      // 清除桥梁隧道搜索栏内容
      // this.sdName = ''
      // this.bridgeName = ''
      //    this.clearGroup();
    },
    bridge() {
      this.current = 1
      this.showBridge = false
      this.showRoad = true
      this.showSd = true
      this.showSearchBridge = true
      this.showSearchSd = false
      this.showSearch = true
      // 清除桥梁隧道搜索栏内容
      // this.sdName = ''
      this.roadbh = ''
      this.roadK = ''
      this.roadAdd = ''
      //     this.clearGroup();
      //      this.initqlwfs();
    },
    sd() {
      this.current = 2
      this.showSd = false
      this.showRoad = true
      this.showBridge = true
      this.showSearchSd = true
      this.showSearchBridge = false
      this.showSearch = true
      // 清除桥梁隧道搜索栏内容
      // this.bridgeName = ''
      this.roadbh = ''
      this.roadK = ''
      this.roadAdd = ''
      //   this.clearGroup();
      //    this.initsdwfs();
    },
    clearGroup() {
      this.sdlist = []
      this.qllist = []
      //  this.lxlist=[];
      this.sdGroup.clearLayers()
      this.qlGroup.clearLayers()
      this.lxGroup.clearLayers()
    },
    // 点击输入框时恢复监听
    allowWatch() {
      this.change = true
    },
    chickItem(type, data, i) {
      this.preventWatch = !this.preventWatch// 阻止监听
      console.log('选择了：', data)
      if (this.isactive == i) {
        if (this.ifCancelTimes % 2 == 1) {
          this.ifCancel = true
        } else {
          this.ifCancel = false
        }
        this.ifCancelTimes++
        console.log('是否点击同一个：', this.ifCancel)
        console.log('次数', this.ifCancelTimes)
      } else {
        this.ifCancel = false
      }

      this.isactive = i
      if (type == 0) {
        this.roadbh = data.properties.lxbm
        // this.roadK = data.properties.qdzh.split('+')[0].slice(1)
        // this.roadAdd = data.properties.qdzh.split('+')[1]
        this.ifshow = false
        // this.clearGroup() //留着会出现，点击路线某一条，在点击桥梁或隧道，为空

        this.querylxwfs(data.properties.lxbm)

        this.selectlx = data.properties
        console.log('点击项的数据：', data)

        // let query = `becd ilike '%${data.properties.lxbm}%'`
        // let queryencodeURI = encodeURIComponent(query)
        // console.log('queryencodeURI' + queryencodeURI)
        // this.initqlwfs(queryencodeURI);
        // this.initsdwfs(queryencodeURI);

        // console.log(type,data)
      } else if (type == 1) {
        console.log('点击桥梁：', data)
        this.bridgeName = data.properties.benm
        this.qlGroup.addTo(this.map)
        this.ifshow = false
        //   console.log(type, data)
        this.map.setZoom(14)
        setTimeout(() => {
          this.map.panTo([data.properties.y, data.properties.x])
        }, 500)

        //    console.log("data.properties.id" + data.properties.id);
        //  console.log(this.sdGroup.eachLayer);

        this.qlGroup.eachLayer(e => {
          //    console.log("111111111", e.id);
          if (e.id == (data.properties.y + ',' + data.properties.x)) {
            e.fire('mouseover')
            e.openPopup()
          }
        })
      } else if (type == 2) {
        this.sdGroup.addTo(this.map)
        this.ifshow = false
        console.log(type, data)
        this.map.setZoom(14)
        setTimeout(() => {
          this.map.panTo([data.properties.y, data.properties.x])
        }, 500)

        this.sdGroup.eachLayer(e => {
          // console.log("111111111", e.id);
          if (e.id == (data.properties.y + ',' + data.properties.x)) {
            e.fire('mouseover')
            e.openPopup()
          }
        })
      }
    }

    // getwfs(){
    //    getsdViewAPI().then(
    //      res => {
    //         console.log("abc" + res);

    //        }).catch( err => console.log(err))
    // },

  }
}
</script>
<style>
.txtK {
  display: flex;
  width: 144px;
  height: 42px;
  background: #ffffff;
  border-radius: 8px;
  align-items: center;
  padding-left: 16px;
  margin-bottom: 8px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
}

.styImg {
  height: 42px;
  display: flex;
  align-items: center;
  margin-right: 8px;
  margin-left: 8px;
}

.checkbox_true_part, .checkbox_false_full, .checkbox_true_full, .checkbox_false_part {
  display: none !important;
}

.map-container {
  position: absolute;
  left: 0;
  top: 0px;
  width: 100%;
  height: 100%;
  z-index: 1;

}

.tit {
  width: 330px;
  height: 50px;
  background-color: rgb(84, 108, 234);
  display: flex;
}

.titTxt {
  height: 26px;
  padding-left: 20px;
  padding-top: 12px;
  font-size: 12px;
  line-height: 26px;
  color: rgba(255, 255, 255, 0.9);

}

.selectOpt {
  height: 29px;
  width: 112px;
  font-size: 12px;
  border: none;
  outline: none;
  border: 1px solid rgba(220, 220, 220, 1);
  margin-top: 10px;
  margin-left: 10px;
  color: #808080;
}

.allInfoLeft {
  width: 418px;
  margin-left: 24px;
  z-index: 2;
  background: rgb(241, 245, 252);
  border-radius: 8px;

}

.se {
  justify-items: left;
  display: flex;
}

.dk {
  z-index: 2;
  width: 36px;
}

.sq {
  margin-left: -24px;
  z-index: 2;
  width: 0px;

}

.allInfo {
  width: 330px;
  position: absolute;
  top: 87px;
  right: 14px;
  z-index: 2;
  background: rgb(255, 255, 255);
}

.titImgg {
  margin-left: auto;

}

.titImg {
  height: 24px;
  width: 24px;
  margin-right: 20px;
  margin-top: 13px;
}

.base {
  width: 330px;
  height: 30px;
  background-color: rgb(239, 245, 255);
  margin-top: 12px;
  font-size: 12px;
  padding-bottom: 5px;
}

.baseTit {
  position: absolute;
  margin-top: 8px;
  margin-bottom: 8px;
  height: 24px;
  max-width: 200px;
  margin-left: 24px;
  color: rgb(0, 0, 0);
  font-weight: 500;
}

.formInfo {
  width: 330px;
}

.formEach {
  display: flex;
  justify-content: space-between;
  margin-top: 8px;
  margin-left: 24px;
}

.formTit {
  color: rgba(0, 0, 0, 1);
  height: 22px;
  font-size: 12px;
}

.formGet {
  margin-right: 19px;
  color: rgba(0, 0, 0, 0.9);
  font-size: 10px;
}

.positionLeft {
  display: flex;
  margin-top: 20px;
  width: 250px;
  z-index: 6;
}

.cql2 {
  /*padding-top: 15.7px;*/
  background: #ffffff;
  border-radius: 8px;
  /*width: 332px;*/
  /*height: 36px;*/
  display: flex;
  flex-wrap: wrap;
}

.selectLast {
  display: flex;
  width: 100%;
}

.eachSelect {
  /*height: 42px;*/
  /*width: 134px;*/
  margin-bottom: 8px;

}

.searchImg {
  width: 24px;
  height: 26px;
  border: 1px solid rgba(220, 220, 220, 1);
  border-right: none;
  margin-left: 20px;
  background: rgb(255, 255, 255);
}

.eachSelectFor {
  height: 42px;
  width: 134px;
  margin-right: 8px;
  border: none;
  padding:0 25px;
  text-align-last: center;
  outline: none;
  border-radius: 8px;
}

.dkImg {
  width: 42px;
  height: 42px;
  margin-left: 24px;
  cursor: pointer;
}

.roadImg {
  width: 24px;
  height: 24px;
}

input {
  outline: none;
}

.treeStyle {
  /*padding-left: 20px;*/

  background: rgb(255, 255, 255);
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
}

.itemChose {
  display: flex;
  color: rgba(0, 0, 0, 0.6);
  height: 48px;
  font-size: 16px;
  justify-content: space-around;
  align-items: center;
  margin-bottom: 8px;
  /*margin-left: -30px;*/
}

.roadChose {
  line-height: 24px;
  height: 42px;
  width: 126px;
  margin-right: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  cursor: pointer;
  font-size: 16px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: left;
  background-color: white;
  border-radius: 8px;
}

.roadChoseTxt {
  color: #559CF9;
  font-size: 16px;
  background-color: white;
  background: rgb(237, 242, 254);
  border-radius: 8px;
  border: 1px solid #559cf9;
}

.infoList {
  /*border: 1px solid;*/
  height: 530px;
  /*设置溢出部分，隐藏底部横向滚动条*/
  overflow: scroll;

  /*display: flex;*/
  /*flex-wrap: wrap;*/
  /*justify-content: center;*/
  /*align-items: center;*/

}

.infoList::-webkit-scrollbar {
  width: 0;
}

.choseInfo {
  display: flex;
  width: 100%;
  height: 66px;
  /*padding-left: 20px;*/

  /*margin-top: 10px;*/
  /*padding-bottom: 20px;*/
}

.addclass {
  display: flex;
  flex-wrap: nowrap;
  width: 100%;
  height: 66px;
  /*padding-left: 20px;*/
  /*margin-top: 10px;*/
  /*padding-bottom: 20px;*/
  background-color: rgb(236, 239, 255);

}

.choseInfo:hover {
  background-color: rgb(236, 239, 255);
  cursor: pointer;
}

.addclass:hover {
  cursor: pointer;
}

.choseInfoTit {
  width: 300px;
  /*height: 22px;*/
  line-height: 30px;
  font-size: 12px;
  text-align: left;
  margin-left: 20px;
  font-size: 16px;
}

.roadChoseBorder {
  /*border:1px solid red;*/
  border-left-color: rgb(231, 231, 231);
  border-right-color: rgb(231, 231, 231);
}

.inp {
  margin-right: 10px;
  /*width: 332px;*/
  margin-left: 10px;
  width: 144px;
  height: 42px;
  border-radius: 8px;
  border: none
}

.sousuo {
  width: 91px;
  height: 42px;
  background: linear-gradient(177deg, #86baff 0%, #3b8cf7 100%);
  border-radius: 8px;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
}

.searchName {
  width: 311px;
  height: 42px;
  border: none;
  border-radius: 8px;
  margin-right: 8px;
}

.titstyle {
  font-size: 18px;
  line-height: 28px;
  height: 28px;
}

.inpii {
  width: 300px;
}

.btn {
  background: linear-gradient(177deg, #86baff 0%, #3b8cf7 100%);
  border: none;
  color: white;
  width: 91px;
  height: 28px;
  border-radius: 4px;
  font-size: 12px;
  font-family: HarmonyOS Sans SC;
  margin-right: 20px;
  cursor: pointer;
}

.info h4 {
  margin: 0 0 5px;
  color: #777;
}
</style>



// WEBPACK FOOTER //
// src/views/ClickFeature.vue